import Tooltips from "./Tooltips.json"
export default Tooltips
